import { getCoreSonarObjectsApplicationsAsyncSlice } from './get';

export const { requestGetCoreSonarObjectsApplications, resetGetCoreSonarObjectsApplications } =
	getCoreSonarObjectsApplicationsAsyncSlice.asyncActionCreators;
